import { PayOrderAmount, PayPartialAmount } from "@/types/orders";
import axios from "axios";
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const orderService = {
  async viewOrder(orderNumber: string) {
    const response = await axios.get(
      `${API_BASE_URL}/order/view/${orderNumber}`
    );
    return response.data;
  },

  async getOrdersByUser(UserID: string | null) {
    const response = await axios.get(`${API_BASE_URL}/order/user/${UserID}`);
    return response.data;
  },

  async generateOrderInvoice(orderNumber: string) {
    const response = await axios.get(
      `${API_BASE_URL}/generate_invoice/${orderNumber}`
    );
    return response.data;
  },
  async payOrderAmount(data: PayOrderAmount) {
    const response = await axios.post(
      `${API_BASE_URL}/credit/order/pay`,
      data
    );
    return response.data;
  },
  async payPartialAmount(data: PayPartialAmount) {
    const response = await axios.post(
      `${API_BASE_URL}/credit/partial/pay`,
      data
    );
    return response.data;
  },
};
